<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tocchaptitle"><a id="loi"></a>List of Illustrations</h1>
<p class="toc"><a href="#/07_chapter01#fig1">1. Cliffside cave, Chicken Foot Mountain, China</a></p>
<p class="toc"><a href="#/10_chapter04#fig2">2. White skeleton visualization method</a></p>
<p class="toc"><span href="#/12_chapter06#fig3" title="Link target outside of Sample">3. The Zhunti Buddha</span></p>
<p class="toc"><span href="#/13_chapter07#fig4" title="Link target outside of Sample">4. The Vairocana Buddha</span></p>
<p class="toc"><span href="#/16_chapter10#fig5" title="Link target outside of Sample">5. The nine-bottled winds exercise</span></p>
<p class="toc"><span href="#/17_chapter11#fig6" title="Link target outside of Sample">6. Kundalini yoga</span></p>
<p class="toc"><span href="#/20_chapter14#fig7" title="Link target outside of Sample">7. Thousand-year-old Chinese recipe for siddhi medicine</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_list-of-illustrations.vue?022f066f